import React from 'react'

const Logo = () => (
    <span className="logo">
        <span className="logo__img" />
    </span>
)

export default Logo



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/components/Header/Logo.jsx